// extracted by mini-css-extract-plugin
export default {"answerLabel":"X_cT","success":"X_cV"};